var map = {
	"./res1.png": "6ed6",
	"./res2.png": "5fb8",
	"./res3.png": "5fa2",
	"./res4.png": "ebb4",
	"./res5.png": "7485",
	"./res6.png": "5b15",
	"./res7.png": "4cb1",
	"./res8.png": "dc1e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "47c1";